import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { Credential, User } from '~/types/model/user'

interface AuthStore {
  user: User | null
  credential: Credential | null
  setUser: (user: User) => void
  setCredential: (credential: Credential) => void
  setAuthUser: (user: User, credential: Credential) => void
  reset: () => void
}

// Storage key for persisted data
export const AUTH_STORE_KEY = 'auth_store'

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      credential: null,
      setUser: (user: User) => set({ user }),
      setCredential: (credential: Credential) => set({ credential }),
      setAuthUser: (user: User, credential: Credential) => set({ user, credential }),
      reset: () => set({ user: null, credential: null }),
    }),
    {
      name: AUTH_STORE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
